// extracted by mini-css-extract-plugin
module.exports = {"spinner":"AppLoader_spinner__ojNYC","spin":"AppLoader_spin__mdwjY","page":"AppLoader_page__2gfE2","block":"AppLoader_block__1dVSS","inline":"AppLoader_inline__3hA0r"};